import React, { useEffect } from "react";
import { useHistoryOperations } from "@/hooks/useHistoryOperations";
import { EntityHistory } from "@/components/common/EntityHistory";

interface WorkforceHistoryTabProps {
	workforceId: string;
}

export const WorkforceHistoryTab = ({ workforceId }: WorkforceHistoryTabProps) => {
	const { history, loading, fetchHistory } = useHistoryOperations('workforce');

	useEffect(() => {
		if (workforceId)
			fetchHistory(workforceId);
	}, [workforceId, fetchHistory]);

	return (
		<div>
			<h3 className="text-lg font-semibold mb-4">Workforce History</h3>
			<EntityHistory history={history} loading={loading} />
		</div>
	);
};
